import React, { useEffect, useState } from 'react';
import axios from 'axios';

const RoundStatusDisplay = () => {
  const [status, setStatus] = useState('loading');
  const [winner, setWinner] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [totalSol, setTotalSol] = useState(0);
  const [nextRound, setNextRound] = useState(null);
  const [prevStatus, setPrevStatus] = useState(null);

  // Fetch from server every 2 seconds
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await axios.get('http://localhost:5000/api/rounds/status');
        console.log('RoundStatusDisplay:', res.data);
        setStatus(res.data.status);
        setWinner(res.data.winner || null);
        setTimeLeft(res.data.time_left);
        setTotalSol(res.data.total_sol || 0);
        setNextRound(res.data.next_round);
      } catch (err) {
        console.error('Error fetching round status:', err);
        setStatus('error');
      }
    };

    fetchStatus();
    const serverInterval = setInterval(fetchStatus, 2000);
    return () => clearInterval(serverInterval);
  }, []);

  // Decrement timer locally every second and reset on status change
  useEffect(() => {
    if (prevStatus !== status) {
      setTimeLeft(status === 'pending' || status === 'live' ? timeLeft : null);
      setPrevStatus(status);
    }
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev && prev > 0 ? prev - 1 : null));
      setNextRound((prev) => (prev && prev > 0 ? prev - 1 : null));
    }, 1000);
    return () => clearInterval(timer);
  }, [status, prevStatus, timeLeft]);

  const formatTime = (seconds) => {
    if (seconds === null || seconds <= 0) return '...';
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    let parts = [];
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
    if (mins > 0 || hours > 0) parts.push(`${mins} minute${mins !== 1 ? 's' : ''}`);
    parts.push(`${secs} second${secs !== 1 ? 's' : ''}`);
    return parts.join(' ');
  };

  return (
    <div style={{ textAlign: 'center', margin: '2rem 0', color: '#00FFFF', fontFamily: 'VT323', fontSize: '1.5rem' }}>
      {status === 'pending' && (
        <>
          <div>Next round in:</div>
          <div>{formatTime(timeLeft)}</div>
        </>
      )}
      {status === 'live' && (
        <>
          <div>Current Round Ends In:</div>
          <div>{formatTime(timeLeft)}</div>
          <div>Total Solana In Play: {totalSol.toFixed(2)} SOL</div>
        </>
      )}
      {(status === 'complete' || status === 'completed') && (
        <>
          {winner ? (
            <div>{winner.ticker} won with {winner.total_contributions} SOL seeded in its LP</div>
          ) : (
            <div>No winner this round</div>
          )}
          <div>Next round in: {formatTime(nextRound || timeLeft)}</div>
        </>
      )}
      {status === 'idle' && (
        <div>No round active or scheduled</div>
      )}
      {status === 'error' && <div>⚠️ Failed to load round info.</div>}
    </div>
  );
};

export default RoundStatusDisplay;